$(function(){

    var $background = $('#background');

    // Fix background image jump on mobile
    if ((/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
        $background.css({'top': 0, 'bottom': 0});

        $(window).resize(sizeBackground);

        sizeBackground();
    }

    function sizeBackground() {
        $background.height(screen.height);
    }



    //////////////////
    // banner logic //
    //////////////////
    function setCookie(cookieName, expiration) {
        var exdays = expiration;
        var cname = cookieName;
        var cvalue = "true"
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    
 

    
 
    // view button
    $('.banner .viewButton').click(function(event) {
        
        window.location = banner_url;

        setTimeout(function(){
            window.location = redirectUrl;
        }, 50);
        
        
        
    });

    // close button
    $('.banner .closeBanner').click(function(event) {
        $('.banner').hide();
        setCookie('bannerClosed', 9);
    });

    //if we don't have cookie display banner
    if (getCookie('bannerClosed') == "") {
        $('.banner').show();
    }
});


// add touch class to body if app
// is on the touch enabled device
if ('ontouchstart' in window|| navigator.maxTouchPoints) {
    document.body.className += ' touch';
}
